import { event } from 'vue-gtag';

const tagId = import.meta.env.VITE_TAG_ID;
export const trackEvent = (eventName: string, params: {}): void => {
    event(eventName, {
        tagId,
        ...params
    });
};